import { css } from "@emotion/css";

export const errorText = css`
  color: #de1609;
  font-size: 14px;
  padding: 2px 20px;
`;
